<template>
    <div>
        <app-header></app-header>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <h2 class="pad-top">Welcome</h2>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'Welcome',
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/Welcome.vue